module.exports = __webpack_public_path__ + "static/media/check-square.75b12164.svg";